import { Tag } from "@arco-design/web-react"
import { TagsDef } from "@/enums/common"

const Colors = {
    success: "green",
    error: "red",
}

const Tags = Object.values(TagsDef).map(({ value, label }) => ({
    id: value,
    name: label
}))

const StatusTag = (props) => {
    const { children, color, error } = props;


    return (
        <Tag {...props}
            color={color ?? Colors[error ? "error" : "success"]}>
            {children}
        </Tag>
    )
}

const StatusTags = (props) => {
    const { value, color, error } = props;

    if (!value) return "";

    return (
        <>
            {value.map((item, index) =>
                <Tag key={index} style={{ marginRight: 5 }}
                    color={color ?? Colors[error ? "error" : "success"]}>
                    {Tags.find((tag) => tag.id === item)?.name}
                </Tag>
            )}
        </>
    )
}

StatusTag.List = StatusTags;

export { StatusTag }